// extracted by mini-css-extract-plugin
export default {"acc_edit__wrapper":"ChangePassword_acc_edit__wrapper__xP5hD","container":"ChangePassword_container__fSUUD"};